var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2504_5802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.6589 28 28 21.6451 28 14C28 6.34117 21.6451 0 13.9863 0C6.34117 0 0 6.34117 0 14C0 21.6451 6.35489 28 14 28Z",
    fill: "#7B7B7B",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17282 20C8.51489 20 8 19.4702 8 18.8115C8 18.4964 8.11441 18.1957 8.34326 17.9808L12.3051 14L8.34326 10.0334C8.11441 9.8043 8 9.51789 8 9.20286C8 8.52982 8.51489 8.02864 9.17282 8.02864C9.50178 8.02864 9.75923 8.14319 9.98807 8.35799L13.9785 12.3389L17.9976 8.34367C18.2407 8.10024 18.4982 8 18.8128 8C19.4707 8 20 8.51551 20 9.17422C20 9.50358 19.8998 9.76133 19.6423 10.0191L15.6663 14L19.6281 17.9666C19.8713 18.1814 19.9856 18.482 19.9856 18.8115C19.9856 19.4702 19.4565 20 18.7842 20C18.4553 20 18.1549 19.8855 17.9403 19.6563L13.9785 15.6754L10.031 19.6563C9.80214 19.8855 9.50178 20 9.17282 20Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2504_5802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconLight);
export default __webpack_public_path__ + "static/media/close-icon-light.46b3285c4de8cc704304a470ab16760e.svg";
export { ForwardRef as ReactComponent };